import * as React from "react";
const Design = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.896 3.896a2.268 2.268 0 0 1 3.208 3.208L11 16.206V17a4 4 0 0 1-4 4H3v-4a4 4 0 0 1 4-4h.793l9.103-9.104ZM10.5 11.707 8.707 13.5l1.793 1.793 1.793-1.793-1.793-1.793Zm2.5 1.086 6.396-6.397a1.268 1.268 0 0 0-1.792-1.792L11.207 11 13 12.793ZM7 14a3 3 0 0 0-3 3v3h3a3 3 0 0 0 3-3v-.793L7.793 14H7Z" }));
Design.displayName = "Design";
var Design_default = Design;
export {
  Design_default as default
};
